import { isNotNullOrUndefined } from '../../../../../lib/typeGuards';

export const dependenciesToIndexFormula = (
  schemaId: string,
  dependencies: string[]
): string => {
  if (dependencies.length === 0) {
    return `f"${schemaId};"`;
  }

  const depParts = dependencies
    .map(dep => `${dep}:{default_to(field.${dep}, "")}`)
    .join(';');

  return `f"${schemaId};${depParts}"`;
};

export const parseCanonicalIndexFormula = (
  formula: string
): { schemaId: string; dependencies: string[] } | null => {
  const trimmed = formula.trim();

  const structureMatch = trimmed.match(/^f"([^;]+);(.*)"$/);
  if (!structureMatch) return null;

  const [, schemaId, depsString] = structureMatch;

  if (!schemaId) return null;

  if (!depsString) {
    return { schemaId, dependencies: [] };
  }

  const depPattern = /([^:;]+):\{default_to\(field\.\1, ""\)\}/g;
  const dependencies = [...depsString.matchAll(depPattern)]
    .map(m => m[1])
    .filter(isNotNullOrUndefined);

  if (dependenciesToIndexFormula(schemaId, dependencies) !== trimmed) {
    return null;
  }

  return { schemaId, dependencies };
};

export const isCanonicalIndexFormula = (
  formula: string,
  expectedSchemaId: string
): boolean => {
  const parsed = parseCanonicalIndexFormula(formula);
  return parsed !== null && parsed.schemaId === expectedSchemaId;
};
